import get from 'lodash.get';
import { getDiets } from '@/services/diet';

// eslint-disable-next-line no-unused-vars
const initializeDiets = async (store) => {
  const getDietsResponse = await getDiets();
  return get(getDietsResponse, 'data.getDiets');
};

export default {
  initializeDiets,
};



// WEBPACK FOOTER //
// ./store/modules/diets/actions.js